if (!customElements.get('wickelplatz-product-builder')) {
  customElements.define('wickelplatz-product-builder', class WickelplatzProductBuilder extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.toggle = this.querySelector('[data-wickelplatz-builder-toggle]');
      this.toggleText = this.querySelector('[data-wickelplatz-toggle-text]');
      this.panel = this.querySelector('[data-wickelplatz-builder-panel]');
      this.counterpartSelect = this.querySelector('[data-wickelplatz-counterpart]');
      this.matSelect = this.querySelector('[data-wickelplatz-mat]');
      this.addButton = this.querySelector('[data-wickelplatz-builder-add]');
      this.message = this.querySelector('[data-wickelplatz-builder-message]');

      const dataElement = this.querySelector('[data-wickelplatz-builder-data]');
      try {
        this.configurations = JSON.parse(dataElement ? dataElement.textContent : '[]');
      } catch (error) {
        this.configurations = [];
      }

      if (!this.toggle || !this.panel || !this.counterpartSelect || !this.matSelect || !this.addButton || this.configurations.length === 0) {
        this.hidden = true;
        return;
      }

      this.hideReplacedProductBlocks();
      this.populateCounterparts();
      this.togglePanel();

      this.toggle.addEventListener('click', () => this.togglePanel());
      this.counterpartSelect.addEventListener('change', () => this.updateCounterpart());
      this.matSelect.addEventListener('change', () => this.updateMat());
      this.addButton.addEventListener('click', () => this.addSet());
    }

    hideReplacedProductBlocks() {
      const productText = this.closest('.product-text');
      if (!productText) return;

      productText.querySelectorAll('.textile-collection-banner').forEach((banner) => {
        const wrapper = banner.closest('.product-custom-liquid');
        if (wrapper) wrapper.hidden = true;
      });

      productText.querySelectorAll('product-recommendations').forEach((recommendations) => {
        if ((recommendations.dataset.url || '').includes('intent=complementary')) {
          recommendations.hidden = true;
        recommendations.style.setProperty('display', 'none', 'important');
        }
      });
    }

    populateCounterparts() {
      this.configurations.forEach((configuration, index) => {
        const option = document.createElement('option');
        option.value = String(index);
        option.textContent = configuration.title
          + (configuration.variant ? ' – ' + configuration.variant : '')
          + ' – ' + configuration.price;
        this.counterpartSelect.appendChild(option);
      });
    }

    togglePanel() {
      const opening = this.panel.hidden;
      this.panel.hidden = !opening;
      this.toggle.setAttribute('aria-expanded', String(opening));
      if (this.toggleText) {
        this.toggleText.textContent = opening
          ? this.dataset.textToggleClose
          : this.dataset.textToggleOpen;
      }
    }

    updateCounterpart() {
      const index = this.counterpartSelect.value;
      this.selectedConfiguration = index === '' ? null : this.configurations[Number(index)];
      this.selectedMat = null;
      this.resetMatSelect();
      this.renderCounterpart();
      this.renderMat();
      this.updateAddButton();

      if (!this.selectedConfiguration) return;

      this.matSelect.innerHTML = '';
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = this.dataset.textSelectDesign + ' – ' + this.selectedConfiguration.size;
      this.matSelect.appendChild(placeholder);

      this.selectedConfiguration.mats.forEach((mat, matIndex) => {
        const option = document.createElement('option');
        option.value = String(matIndex);
        option.textContent = mat.title + ' – ' + mat.variant + ' – ' + mat.price;
        this.matSelect.appendChild(option);
      });

      this.matSelect.disabled = false;
      const size = this.querySelector('[data-wickelplatz-size]');
      if (size) {
        size.textContent = this.dataset.textMatchingSize + ': ' + this.selectedConfiguration.size;
        size.hidden = false;
      }
    }

    resetMatSelect() {
      this.matSelect.innerHTML = '';
      const option = document.createElement('option');
      option.value = '';
      option.textContent = this.dataset.textSelectCounterpartFirst;
      this.matSelect.appendChild(option);
      this.matSelect.disabled = true;

      const size = this.querySelector('[data-wickelplatz-size]');
      if (size) {
        size.textContent = '';
        size.hidden = true;
      }
    }

    updateMat() {
      const index = this.matSelect.value;
      this.selectedMat = this.selectedConfiguration && index !== ''
        ? this.selectedConfiguration.mats[Number(index)]
        : null;
      this.renderMat();
      this.updateAddButton();
    }

    renderCounterpart() {
      const preview = this.querySelector('[data-wickelplatz-counterpart-preview]');
      if (!preview) return;
      preview.hidden = !this.selectedConfiguration;
      if (!this.selectedConfiguration) return;

      this.updateImage(
        this.querySelector('[data-wickelplatz-counterpart-image]'),
        this.selectedConfiguration.image,
        this.selectedConfiguration.imageAlt
      );

      const title = this.querySelector('[data-wickelplatz-counterpart-title]');
      const variant = this.querySelector('[data-wickelplatz-counterpart-variant]');
      const price = this.querySelector('[data-wickelplatz-counterpart-price]');
      if (title) title.textContent = this.selectedConfiguration.title;
      if (variant) variant.textContent = this.selectedConfiguration.variant;
      if (price) price.textContent = this.selectedConfiguration.price;
    }

    renderMat() {
      const preview = this.querySelector('[data-wickelplatz-mat-preview]');
      if (!preview) return;
      preview.hidden = !this.selectedMat;
      if (!this.selectedMat) return;

      this.updateImage(
        this.querySelector('[data-wickelplatz-mat-image]'),
        this.selectedMat.image,
        this.selectedMat.imageAlt
      );

      const title = this.querySelector('[data-wickelplatz-mat-title]');
      const design = this.querySelector('[data-wickelplatz-mat-design]');
      const variant = this.querySelector('[data-wickelplatz-mat-variant]');
      const price = this.querySelector('[data-wickelplatz-mat-price]');
      if (title) title.textContent = this.selectedMat.title;
      if (design) design.textContent = this.selectedMat.design ? this.dataset.textDesignLabel + ': ' + this.selectedMat.design : '';
      if (variant) variant.textContent = this.dataset.textSizeLabel + ': ' + this.selectedMat.variant;
      if (price) price.textContent = this.selectedMat.price;
    }

    updateImage(image, source, alt) {
      if (!image) return;
      image.src = source || '';
      image.alt = alt || '';
      image.hidden = !source;
    }

    updateAddButton() {
      this.addButton.disabled = this.busy || !this.selectedConfiguration || !this.selectedMat;
    }

    async addSet() {
      if (this.busy || !this.selectedConfiguration || !this.selectedMat) return;

      const productForm = document.getElementById(this.dataset.productFormId);
      const variantInput = productForm ? productForm.querySelector('input[name="id"]') : null;
      const quantityInput = productForm ? productForm.querySelector('input[name="quantity"]') : null;
      const currentVariantId = variantInput ? String(variantInput.value) : '';

      if (!currentVariantId) {
        this.message.textContent = this.dataset.textSelectVariantFirst;
        return;
      }

      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      this.addButton.disabled = true;
      this.message.textContent = this.dataset.textAdding;

      const quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;
      const items = [
        { id: currentVariantId, quantity: quantity },
        { id: String(this.selectedConfiguration.id), quantity: 1 },
        { id: String(this.selectedMat.id), quantity: 1 }
      ];

      try {
        const addResponse = await fetch(window.KROWN.settings.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: items })
        });

        const addResult = await addResponse.json();
        if (!addResponse.ok || addResult.status === 422) {
          throw new Error(addResult.description || addResult.message || window.KROWN.settings.locales.cart_general_error);
        }

        if (typeof window.refreshCart === 'function') {
          window.refreshCart(true);
        } else {
          window.location.href = window.KROWN.settings.routes.cart_url;
          return;
        }

        const cartForm = document.getElementById('AjaxCartForm');
        if (cartForm) cartForm.dispatchEvent(new Event('cart-updated'));

        if (window.KROWN && KROWN.functions) {
          KROWN.functions.eventDispatcher('krown:cart:add', {
            variantId: String(this.selectedMat.id),
            source: 'wickelplatz-product-builder'
          });

          if (typeof KROWN.functions.dispatchStandardEvent === 'function') {
            KROWN.functions.dispatchStandardEvent('CartLinesUpdateEvent', document, {
              action: 'add',
              context: 'product',
              lines: items.map((item) => ({
                merchandiseId: String(item.id),
                quantity: item.quantity
              })),
              promise: Promise.resolve({ cart: null })
            });
          }
        }

        this.message.textContent = this.dataset.textAdded;

        const screenReader = document.getElementById('screen-reader-info');
        if (screenReader) {
          screenReader.textContent = this.dataset.textAdded;
          setTimeout(() => {
            screenReader.textContent = '';
          }, 1500);
        }
      } catch (error) {
        this.message.textContent = error && error.message
          ? error.message
          : window.KROWN.settings.locales.cart_general_error;
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.updateAddButton();
      }
    }
  });
}